import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

import ca from 'date-fns/locale/ca';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import pt from 'date-fns/locale/pt';
import DatePicker, { registerLocale } from 'react-datepicker';
import styled from 'styled-components';

import { LanguageType } from '@nx-smartmonkey/shared/domain';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { de, fr } from 'date-fns/locale';

registerLocale(`es`, es);
registerLocale(`es-CA`, ca);
registerLocale(`en-US`, en);
registerLocale(`pt`, pt);
registerLocale(`de`, de);
registerLocale(`fr`, fr);

const StyledDatePickerWrapper = styled.div`
  .react-datepicker {
    font-size: 16px; /* Increase font size */
    width: 600px; /* Set width */
    background-color: transparent; /* Change background color */
    border: unset;
  }
  .react-datepicker__navigation {
    scale: 1.5; /* Increase navigation icon size */
    height: unset; /* Increase navigation icon height */
  }
  .react-datepicker__current-month {
    height: 50px; /* Increase current month height */
  }
  .react-datepicker__header {
    background-color: transparent; /* Change header background color */
    color: transparent; /* Change header text color */
  }
  .react-datepicker__current-month {
    font-size: 16px; /* Increase current month font size */
    font-weight: 400; /* Change current month font weight */
  }

  .react-datepicker__day-name {
    font-size: 14px;
    width: 73px;
    padding-bottom: 7px;
  }
  .react-datepicker__day {
    font-size: 14px;
    padding: 14px 23px;
  }
  .react-datepicker__header {
    width: 600px;
  }
  .react-datepicker__day--selected {
    background-color: ${RoutalPalette.primary40}; /* Change selected day background color */
    color: white; /* Change selected day text co2lor */
  }
  .react-datepicker__day--previous {
    background-color: ${RoutalPalette.error.dark}; /* Change selected day background color */
    color: white; /* Change selected day text co2lor */
  }
  .react-datepicker__day.react-datepicker__day--keyboard-selected {
    background-color: ${RoutalPalette.primary00}; /* Change selected day background color */
    color: white; /* Change selected day text co2lor */
  }
  .react-datepicker__day--outside-month {
    color: ${RoutalPalette.neutral20}; /* Change outside month day text color */
  }
  .react-datepicker__navigation-icon--next::before {
    border-color: ${RoutalPalette.secondary20}; /* Change next month icon color */
  }
  .react-datepicker__navigation-icon--previous::before {
    border-color: ${RoutalPalette.secondary20}; /* Change next month icon color */
  }
`;

interface CalendarPlanCreationProps {
  portalId?: string;
  dateValue?: Date | null;
  minDate?: Date;
  locale?: LanguageType;
  onChange: (date: Date) => void;
}

export const CalendarPlanCreation = ({
  portalId,
  dateValue,
  minDate,
  locale = `es`,
  onChange,
}: CalendarPlanCreationProps) => {
  const getDatePickerLocale = () => {
    switch (locale) {
      case `en`:
        return `en-US`;
      default:
        return locale;
    }
  };

  const getDatePickerFormat = () => {
    switch (locale) {
      case `en`:
        return `MM/dd/yyyy`;
      default:
        return `dd/MM/yyyy`;
    }
  };

  return (
    <StyledDatePickerWrapper>
      <DatePicker
        selected={dateValue}
        onChange={(date) => {
          if (date) {
            onChange(date);
          }
        }}
        inline
        minDate={minDate}
        disabledKeyboardNavigation
        locale={getDatePickerLocale()}
        // customInput={<DatePickerInput ref={customInputRef} />}
        popperModifiers={[
          {
            name: `arrow`,
            options: {
              padding: ({ popper, reference, placement }) => ({
                right: Math.min(popper.width, reference.width) - 24,
              }),
            },
          },
        ]}
        dateFormat={getDatePickerFormat()}
        portalId={portalId}
        className="custom-date-picker" // Apply custom class
      />
    </StyledDatePickerWrapper>
  );
};
